import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useEmployeesManagement from "../../../hooks/Admin/Employee/useEmployeesManagement";

export default function EmployeeMatrixPage() {
  const [educations, setEducations] = useState([]);
  const [employments, setEmployments] = useState([]);
  const [showEducation, setShowEducation] = useState(true);
  const [showEmployment, setShowEmployment] = useState(true);

  const { id: userId } = useParams(); // Extract userId from the route
  // const navigate = useNavigate();
  const { singleEmployee, fetchSingleEmployee } =
    useEmployeesManagement();

  // const goBack = () => {
  //   navigate(-1);
  // };

  useEffect(() => {
    if (userId && singleEmployee === null) {
      fetchSingleEmployee(userId);
    }
  }, [userId, fetchSingleEmployee, singleEmployee]);

  useEffect(() => {
    if (singleEmployee) {
      setEducations(singleEmployee.previousEducations || []);
      setEmployments(singleEmployee.previousEmployments || []);
    }
  }, [singleEmployee]);

  // // Dummy education data
  // const educations = [
  //   {
  //     qualification: "Ex modi qui ut persp",
  //     institute: "Vitae quis ea do ius",
  //     awardDate: "2025-05-13",
  //     courseLength: "Dolorem vero volupta",
  //     contactName: "Quyn Chaney",
  //     contactEmail: "mejezyhaqu@mailinator.com",
  //     contactNumber: "189",
  //     fromDate: "2021-04-30T00:00:00",
  //     toDate: "2022-05-29T00:00:00",
  //   },
  //   {
  //     qualification: "Voluptatem enim sapi",
  //     institute: "Nesciunt reprehende",
  //     awardDate: "2025-04-30",
  //     courseLength: "Suscipit magna amet",
  //     contactName: "Giselle Carroll",
  //     contactEmail: "fyzuliris@mailinator.com",
  //     contactNumber: "4",
  //     fromDate: "2023-05-01T00:00:00",
  //     toDate: "2023-09-27T00:00:00",
  //   },
  //   {
  //     qualification: "Voluptatem quae accu",
  //     institute: "Cum sed in enim quia",
  //     awardDate: "2025-05-12",
  //     courseLength: "Id dolor nesciunt ",
  //     contactName: "Kylee Barr",
  //     contactEmail: "nirilaloq@mailinator.com",
  //     contactNumber: "63",
  //     fromDate: "2025-05-04T00:00:00",
  //     toDate: "2025-05-27T00:00:00",
  //   },
  //   {
  //     qualification: "Ut odio dolorem volu",
  //     institute: "Est nesciunt inven",
  //     awardDate: "2025-05-05",
  //     courseLength: "Voluptates aut eius ",
  //     contactName: "Noel Gray",
  //     contactEmail: "wycofiqada@mailinator.com",
  //     contactNumber: "672",
  //     fromDate: "2025-04-30T00:00:00",
  //     toDate: "2025-05-27T00:00:00",
  //   },
  // ];

  // // Dummy employment data
  // const employments = [
  //   {
  //     companyName: "Tucker Navarro Inc",
  //     companyAddress: "Valencia Patton Trading",
  //     contactName: "Damian Hill",
  //     contactEmail: "qugelili@mailinator.com",
  //     contactNumber: "470",
  //     jobTitle: "Accusamus dignissimo",
  //     jobDescription: "Magna esse exercitat",
  //     reasonForLeaving: "Nostrum minima inven",
  //     employmentStartDate: "2023-05-01",
  //     employmentEndDate: "2025-05-09",
  //   },
  //   {
  //     companyName: "Conrad Slater Trading",
  //     companyAddress: "Tyson Yang Traders",
  //     contactName: "Dakota Skinner",
  //     contactEmail: "botati@mailinator.com",
  //     contactNumber: "763",
  //     jobTitle: "Reprehenderit omnis ",
  //     jobDescription: "Suscipit aut id quae",
  //     reasonForLeaving: "Ratione dolore cillu",
  //     employmentStartDate: "2025-05-02",
  //     employmentEndDate: "2025-05-30",
  //   },
  //   {
  //     companyName: "Sargent Hess Co",
  //     companyAddress: "Randall Daugherty Co",
  //     contactName: "Jane Hunt",
  //     contactEmail: "sipuk@mailinator.com",
  //     contactNumber: "840",
  //     jobTitle: "Nostrud in inventore",
  //     jobDescription: "Non iure error in qu",
  //     reasonForLeaving: "Iure id natus expli",
  //     employmentStartDate: "2025-05-20",
  //     employmentEndDate: "2025-05-29",
  //   },
  // ];

  // Generate month labels (2020 to 2025)
  const months = [];
  for (let year = 2020; year <= 2025; year++) {
    for (let month = 0; month < 12; month++) {
      const date = new Date(year, month);
      months.push(
        date.toLocaleString("default", { month: "long", year: "numeric" })
      );
    }
  }

  // Convert month string (e.g., May 2025) to Date
  const monthToDate = (monthStr) => {
    const [monthName, year] = monthStr.split(" ");
    const monthIndex = new Date(`${monthName} 1, 2000`).getMonth();
    return new Date(parseInt(year), monthIndex, 1);
  };

  // Check if a month is in a date range
  const isInDateRange = (monthStr, start, end) => {
    const current = monthToDate(monthStr);
    return new Date(start) <= current && current <= new Date(end);
  };

  // Check if a month is inside any record in a list
  const isInAny = (monthStr, dataList, startKey, endKey) =>
    dataList.some((item) =>
      isInDateRange(monthStr, item[startKey], item[endKey])
    );

  // Chunk months into rows of 10
  const rows = [];
  for (let i = 0; i < months.length; i += 10) {
    rows.push(months.slice(i, i + 10));
  }

  return (
    <div className="container-fluid" style={{ padding: " 0px 50px" }}>
      <h2 className="fw-bold mb-4">Five-Year Working Matrix</h2>

      <div className="table-responsive">
        <table className="table table-bordered border-dark">
          <tbody>
            {rows.map((row, i) => (
              <tr key={i}>
                {row.map((month, j) => {
                  const isEdu =
                    showEducation &&
                    isInAny(month, educations, "fromDate", "toDate");
                  const isEmp =
                    showEmployment &&
                    isInAny(
                      month,
                      employments,
                      "employmentStartDate",
                      "employmentEndDate"
                    );

                  return (
                    <td
                      key={j}
                      className={`text-white p-3`}
                      style={{
                        background: isEdu ? "#03c04a" : isEmp ? "#0083ff" : "white",
                        minHeight: "100px",
                        height: "100px",
                        width: "10%",
                        verticalAlign: "top",
                        position: "relative",
                        border: "1px solid #000",
                      }}
                    >
                      {month}
                      {isEdu && (
                        <span
                          style={{ border: "1px solid #000", background: "#03c04a" }}
                          className="badge position-absolute top-0 start-0 m-1"
                        >
                          Education
                        </span>
                      )}
                      {isEmp && (
                        <span
                          style={{ border: "1px solid #000", background: "#0083ff" }}
                          className="badge position-absolute bottom-0 start-0 m-1"
                        >
                          Employment
                        </span>
                      )}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Legend */}
      <div className="mt-3">
        <h5>Legend:</h5>
        <div className="mb-3">
          <label className="me-3" style={{ cursor: "pointer" }}>
            <input
              type="checkbox"
              checked={showEducation}
              onChange={() => setShowEducation(!showEducation)}
              className="form-check-input me-1"
            />
            Show Education
          </label>
          <label style={{ cursor: "pointer" }}>
            <input
              type="checkbox"
              checked={showEmployment}
              onChange={() => setShowEmployment(!showEmployment)}
              className="form-check-input me-1"
            />
            Show Employment
          </label>
        </div>

        <div className="d-flex gap-3">
          <div className="d-flex align-items-center">
            <div
              className="border border-dark me-2"
              style={{ width: "20px", height: "20px", background: "white" }}
            ></div>
            <small>None</small>
          </div>
          <div className="d-flex align-items-center">
            <div
              className="bg-opacity-25 border border-dark me-2"
              style={{ width: "20px", height: "20px", background: "#03c04a" }}
            ></div>
            <small>Education</small>
          </div>
          <div className="d-flex align-items-center">
            <div
              className="bg-opacity-25 border border-dark me-2"
              style={{ width: "20px", height: "20px", background: "#0083ff" }}
            ></div>
            <small>Employment</small>
          </div>
        </div>
      </div>
    </div>
  );
}
